import { render, staticRenderFns } from "./termConditionAirpoints.vue?vue&type=template&id=719f42c4&scoped=true&"
var script = {}
import style0 from "./termConditionAirpoints.vue?vue&type=style&index=0&id=719f42c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719f42c4",
  null
  
)

export default component.exports